// @flow
import React, {PureComponent} from 'react';
import {compose} from 'redux';
import {injectIntl} from 'react-intl';
import QuantitySelector from '@homeaway/react-quantity';
import {triggerSelectUnselectFilterEdapEvent} from '../../utils/filtersEdapUtils';

import './BathroomsFilter.less';

import type {IntlShape} from 'react-intl';

type LabelComponentProps = {
    data: {
        label: string,
        value: string
    }
};

type Props = {
    intl: IntlShape,
    maxBathrooms: ?number,
    minBathrooms: number,
    onChange: Function,
    className?: string
};

export const LabelComponent = ({data: {label, value}}: LabelComponentProps) => {
    const labelComp =
        label !== '' ? (
            <span className="BathroomsFilter__label">{label}</span>
        ) : null;
    return (
        <div>
            <span className="BathroomsFilter__value">{value}</span>
            {labelComp}
        </div>
    );
};

export class BathroomsFilter extends PureComponent<Props> {
    render() {
        const props = this.props;
        const {formatMessage} = props.intl;

        const handleBathroomCountChange = (bathroomsCount: number) => {
            const {onChange} = props;
            const params = {};

            params.minBathrooms = bathroomsCount;

            triggerSelectUnselectFilterEdapEvent({
                eventaction: 'filter selected',
                eventlabel: `bathrooms_min_${bathroomsCount}`
            });

            onChange(params);
        };

        const {minBathrooms, className = ''} = props;
        const bathroomLabel = formatMessage({
            id: 'bathroomsLabel',
            defaultMessage: 'Bathrooms',
            description: 'Label for the amount of Bathrooms to filter on'
        });
        const bathroomValue = formatMessage(
            {
                id: 'bathroomsValueLabel',
                defaultMessage:
                    '{bathroomsCount, plural, =0 {Any} other {{bathroomsCount}+}}',
                description: 'Specifies any bathroom count to filter on'
            },
            {bathroomsCount: props.minBathrooms}
        );

        return (
            <div
                role="menuitem"
                aria-label={bathroomLabel}
                className={`BathroomsFilter ${className}`}
                data-wdio="BathroomsFilter"
            >
                <div className="BathroomsFilter__QuantitySelector BathroomsFilter__row form-group">
                    <QuantitySelector
                        increaseLabel={formatMessage({
                            id: 'bathroomsFilterIncreaseLabel',
                            defaultMessage: 'Increase bathrooms',
                            description:
                                'Increases the amount of bathrooms to filter search by'
                        })}
                        decreaseLabel={formatMessage({
                            id: 'bathroomsFilterDecreaseLabel',
                            defaultMessage: 'Decrease bathrooms',
                            description:
                                'Decreases the amount of bathrooms to filter search by'
                        })}
                        id="BathroomsFilter__quantity"
                        value={minBathrooms}
                        onIncrement={handleBathroomCountChange}
                        onDecrement={handleBathroomCountChange}
                        max={50}
                        label={LabelComponent}
                        labelData={{
                            value: bathroomValue,
                            label: bathroomLabel
                        }}
                    />
                </div>
            </div>
        );
    }
}

export default compose(injectIntl)(BathroomsFilter);
